<template>
  <div class="time-select-container">
    <DropdownSelect
        :label="label"
        :modelValue="modelValue"
        :options="timeOptions"
        :maxTextLength="15"
        @update:modelValue="handleTimeChange"
    >
      <template #option="{ option }">
        <div class="option-content">
          <img v-if="option.iconPath" :src="option.iconPath" class="option-icon" />
          <span>{{ option.label }}</span>
        </div>
      </template>
    </DropdownSelect>

    <DateFilter
        v-if="showDateFilter"
        :visible="showDateFilter"
        :on-filter="handleDateFilterApply"
        @click.stop
    />
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import DropdownSelect from './DropdownSelect.vue';
import DateFilter from '@/components/table-filters/DateFilter.vue';
import { useRouter, useRoute } from 'vue-router';

const { t } = useI18n();
const router = useRouter();
const route = useRoute();

const props = defineProps({
  label: {
    type: String,
    default: ''
  },
  modelValue: {
    type: [String, Number],
    default: 'week'
  }
});

const emit = defineEmits(['update:modelValue']);

const showDateFilter = ref(false);

const timeOptions = computed(() => [
  { value: 'week', label: t('lastWeek') },
  { value: 'month', label: t('lastMonth') },
  { value: 'year', label: t('lastYear') },
  {
    value: 'custom',
    label: t('date_range')
  }
]);

const handleTimeChange = (value) => {
  console.log('🕐 TimeSelectBox: Value changed to:', value);

  if (value === 'custom') {
    showDateFilter.value = true;
  } else {
    const newQuery = { ...route.query };
    delete newQuery['created_at[start]'];
    delete newQuery['created_at[end]'];

    router.push({ query: newQuery }).then(() => {
      emit('update:modelValue', value);
    });
  }
};

const formatDateForBackend = (dateString) => {
  if (!dateString) return undefined;
  const [day, month, year] = dateString.split('-');
  return `${year}-${month}-${day}`;
};

const handleDateFilterApply = (filters) => {
  console.log('📅 TimeSelectBox: DateFilter applied with:', filters);

  showDateFilter.value = false;

  const formattedStartDate = formatDateForBackend(filters.startDate);
  const formattedEndDate = formatDateForBackend(filters.endDate);

  console.log('🚀 TimeSelectBox: Updating URL with dates:', {
    'created_at[start]': formattedStartDate,
    'created_at[end]': formattedEndDate
  });

  router.push({
    query: {
      ...route.query,
      'created_at[start]': formattedStartDate,
      'created_at[end]': formattedEndDate
    }
  }).then(() => {
    emit('update:modelValue', 'custom');
  });
};
</script>

<style scoped>
.time-select-container {
  position: relative;
}

.option-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.option-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}
</style>
